// @vue/component

import ModalManager from '../../services/modalManager';
import updateQueryStringParameter from '../../services/updateQueryStringParameter';

export default {
    methods: {
        openAppointmentCreateModal(queryString) {
            const contactRequestId = this.$store.state.calendar.createAppointmentContactRequestId;

            const baseUrl = `/calendar/appointment/create${queryString.includes('?') ? '' : '?'}${queryString}`;
            const url = contactRequestId ? updateQueryStringParameter(baseUrl, 'contact_request_id', contactRequestId) : baseUrl;

            ModalManager
                .openModal(url, undefined, undefined, 'large')
                .then(result => {
                    if (contactRequestId && result?.id) {
                        this.$store.dispatch('calendar/fetchContactRequestsCounter');
                        this.$store.commit('calendar/resetCreateAppointmentContactRequestId');

                        const actionRecipientId = this.$store.state.calendar.createAppointmentContactRequestActionRecipientId;

                        // When the user navigated from an action, return to the action instead of showing the contact-requests.
                        if (actionRecipientId) {
                            if (this.$store.state.calendar.redirectToActionAfterAppointmentEnabled) {
                                window.location.href = `/dashboard/received-actions/${actionRecipientId}/edit`;
                            }

                            return;
                        }

                        return ModalManager.openModal('/calendar/contact-requests', undefined, undefined, 'full').then(() =>
                            this.$store.dispatch('calendar/fetchContactRequestsCounter'));
                    }
                });
        },
    },
};
